import React from 'react';

interface DialRingProps {
  ctx: CanvasRenderingContext2D;
  centerX: number;
  centerY: number;
  radius: number;
  progress: number;
  rotation: number;
}

export const drawDialRing = ({
  ctx,
  centerX,
  centerY,
  radius,
  progress,
  rotation
}: DialRingProps) => {
  // Ensure radius is positive
  const safeRadius = Math.max(radius, 1);
  
  // Draw main progress arc
  const startAngle = -Math.PI / 2;
  const endAngle = startAngle + (Math.PI * 2 * progress) / 100;

  // Create gradient for the main ring
  const gradient = ctx.createLinearGradient(
    centerX - safeRadius,
    centerY - safeRadius,
    centerX + safeRadius,
    centerY + safeRadius
  );
  gradient.addColorStop(0, '#00ff94');
  gradient.addColorStop(0.5, '#0066ff');
  gradient.addColorStop(1, '#00ff94');

  // Draw background ring
  ctx.beginPath();
  ctx.arc(centerX, centerY, safeRadius, 0, Math.PI * 2);
  ctx.strokeStyle = 'rgba(0, 255, 148, 0.1)';
  ctx.lineWidth = 20;
  ctx.stroke();

  // Draw progress arc with gradient
  ctx.beginPath();
  ctx.arc(centerX, centerY, safeRadius, startAngle, endAngle);
  ctx.strokeStyle = gradient;
  ctx.lineWidth = 20;
  ctx.lineCap = 'round';
  ctx.stroke();

  // Add glow effect
  ctx.shadowColor = '#00ff94';
  ctx.shadowBlur = 15;
  ctx.stroke();
  ctx.shadowBlur = 0;
};